module.exports = __webpack_public_path__ + "img/playstation-1.743181bb.png";